import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { dynamicsAxAuthTypes, IViolation, shellStringResources, Credential, IAttribute } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsAX.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.DynamicsAX_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.DynamicsAX_DisplayText)
    ]
})
export class DynamicsAXLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly AAD_RESOURCE_ID: IAttribute;
    public static readonly SERVICE_PRINCIPLE_ID: IAttribute;
    public static readonly SERVICE_PRINCIPLE_KEY: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Url,
        association: 'URL',
        templatable: true
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AADResourceId,
        association: 'AAD_RESOURCE_ID',
        templatable: true
    })
    public aadResourceId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPLE_ID',
        templatable: true
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        association: 'SERVICE_PRINCIPLE_KEY',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: DynamicsAXLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: DynamicsAXLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice && linkedservice.authenticationType === dynamicsAxAuthTypes.UserAuth && !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
